import { registerHandler } from '@/utils/queues/pc-queues'

export const registerHandlerElementGenericSampleKitRequest = (): void => {
  registerHandler('element.genericSampleKitRequest', function () {
    import(
      /* webpackChunkName: '@/promotion/generic-sample-kit-request/app' */ '@/promotion/generic-sample-kit-request/app'
    )
  })
}
